// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../AppData/Roaming/npm/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list__container{display:flex}.list__sidebar{flex:1 0 400px;background:red}.m-policy-listing container{flex:1 1 auto}", ""]);
// Exports
module.exports = exports;
